import axios, { AxiosResponse } from "axios";
import { environment } from "../../../environments/environment";
import { FormValues } from "../../../components/Invoice/InvoiceCreatorProfile/CompanyDetails/CompanyDetails";
import { InvoiceFormValues } from "../../../components/Invoice/InvoiceCreatorProfile/InvoiceDefaults/InvoiceDefaults";
import { extractFileName } from "../../../utils/extractFileName";
import { BankFormValues } from "../../../components/Invoice/InvoiceCreatorProfile/BankDetails/BankDetails";
import { getValue } from "../../../utils/getValue";

export interface IProfileStep1Payload {
	businessName: string;
	businessTypeId: number;
	websiteLink: string;
	taxId: string;
	phoneNumber: string;
	address: string;
	countryId: number;
	logoImage: File | null;
	taxDocument: File | null;
	digitalSignImage: File | null;
	additionalDataJson?: string;
}

export interface TaxDetail {
	taxName: string;
	taxPercent: number;
}

export interface InvoiceDefaultResponse {
	defaultCurrencyId: number;
	defaultCurrencyCountryCode: string | null;
	paymentTermsDays: number;
	taxDetails: TaxDetail[];
	additionalFieldData: Record<string, string>;
}

export interface BankDetails {
	bankName: string;
	accountTypeId: number;
	routingNumber: string;
	accountNumber: string;
	ibanNumber:string;
	additionalFieldData: Record<string, string>;
}

export interface CreatorProfileData {
	individualName: string;
	businessName: string;
	businessTypeId: number;
	businessEmail: string;
	websiteLink: string;
	taxId: string;
	phoneNumber: string;
	postalAddressLine: string;
	provinceState: string;
	townCity: string;
	postalCode: string;
	countryId: number;
	countryCode: string;
	currencyCode: string;
	logoUrl: string;
	hasTaxDocument: boolean;
	hasDigitalSignature: boolean;
	stepCompleted: number;
	isApproved: boolean;
	profileStatusName: string;
	isFreelancer: boolean;
	registerReasonId?: number;
	isOther: boolean;
	registerReasonOther?: string;
	genderId: number;
	occupationId: number;
	additionalFieldData: Record<string, string>;
	invoiceDefaultResponse: InvoiceDefaultResponse;
	bankDetails: BankDetails;
}

export interface ProfileResponse {
	success: boolean;
	message: string;
	data?: CreatorProfileData;
}
export interface DownloadDocumentParams {
	userId?: number;
	docType?: string;
	customerId?: string;
	invoiceId?: number;
}

export class CreatorProfileService {
	private static URL: string = environment.invoiceApiUrl;
	public static async getProfile(id: string): Promise<ProfileResponse> {
		try {
			// const endpoint = "https://localhost:21000/v1/InvoiceAdmin/creator-profile?userId=" + id;
			const endpoint = `${this.URL}/v1/InvoiceAdmin/creator-profile?userId=` + id;
			const config = {
				headers: { Authorization: `Bearer ${getValue(sessionStorage.getItem("Token"))}` }
			};
			const response: AxiosResponse<ProfileResponse> = await axios.get(endpoint, config);
			return response.data;
		} catch (error: any) {
			throw error;
		}
	}

	public static async getDocument(params: DownloadDocumentParams): Promise<{ file: File; url: string }> {
		// const endpoint = `https://localhost:21000/v1/InvoicingDocument/download`;
		const endpoint = `${this.URL}/v1/InvoicingDocument/download`;
		try {
			const response = await axios.get(endpoint, {
				responseType: "blob",
				params: {
					userId: params.userId,
					docType: params.docType,
					customerId: params.customerId,
					invoiceId: params.invoiceId
				},
				headers: {
					Authorization: `Bearer ${getValue(sessionStorage.getItem("Token"))}`,
					Accept: "*/*"
				}
			});

			const contentDisposition = response.headers["content-disposition"];
			const fileName = contentDisposition ? extractFileName(contentDisposition) : "document";

			const file = new File([response.data], fileName, { type: response.data.type });
			return { file, url: URL.createObjectURL(response.data) };
		} catch (error) {
			throw error;
		}
	}

	public static submitProfileStep1 = async (payload: FormValues,userId: string) => {
		// const endpoint = `https://localhost:21000/v1/InvoiceAdmin/creator-profile-step-1?userId=${userId}`;
		const endpoint = `${this.URL}/v1/InvoiceAdmin/creator-profile-step-1?userId=${userId}`;
		const fd = new FormData();

		Object.entries(payload).forEach(([key, value]) => {
			if (value !== undefined && value !== null) {
				fd.append(key, value);
			}
		});
		const config = {
			headers: { Authorization: `Bearer ${getValue(sessionStorage.getItem("Token"))}` }
		};
		const res = await axios.post(endpoint, fd, config);
		return res.data;
	};

	public static async submitProfileStep2(dropdownIds: InvoiceFormValues,userId: string) {
		// const endpoint = `https://localhost:21000/v1/InvoiceAdmin/creator-profile-step-2?userId=${userId}`;
		const endpoint = `${this.URL}/v1/InvoiceAdmin/creator-profile-step-2?userId=${userId}`;
		const config = {
			headers: { Authorization: `Bearer ${getValue(sessionStorage.getItem("Token"))}` }
		};
		return axios.post<any>(endpoint, dropdownIds, config);
	}

	public static async submitProfileStep3(dropdownIds: BankFormValues, userId: string) {
		// const endpoint = `https://localhost:21000/v1/InvoiceAdmin/creator-profile-step-3?userId=${userId}`;
		const endpoint = `${this.URL}/v1/InvoiceAdmin/creator-profile-step-3?userId=${userId}`;
		const config = {
			headers: { Authorization: `Bearer ${getValue(sessionStorage.getItem("Token"))}` }
		};
		return axios.post<any>(endpoint, dropdownIds, config);
	}
}
